const fetch = require("node-fetch")
const allCountriesQuery = `${process.env.GATSBY_BO_URL}/api/v2/allCountries`

/*HARDCODED UNTIL WE CAN USE THE REAL DATA FROM THE DATABASE */

const pricePagesLinks = arrCountries => {
  const pricePages = {
    titleKey: "sitemap_Price_pages_title",
    title: "Price pages",
    multilanguage: true,
    links: [],
  }

  arrCountries.forEach((country, index) => {
    pricePages.links.push({
      id: index,
      text: `${country.name}_sitemap`,
      url:
        country.name === "International"
          ? "scrap-metal-price"
          : `scrap-metal-price/${country.slug}`,
    })
  })

  return pricePages
}

const materialPricePagesLinks = arrCountries => {
  /*HARDCODED UNTIL WE CAN USE THE REAL DATA FROM THE DATABASE */

  const materialList = [
    "aluminium",
    "copper",
    "brass",
    "stainless-steel",
    "iron-and-steel",
    "lead",
    "zinc",
    "tin",
  ]

  const materialPriceLinks = []

  arrCountries.forEach((country, index) => {
    materialList.forEach((material, index2) => {
      materialPriceLinks.push({
        id: `${index}-${index2}`,
        text: `${country.name} - ${material}`,
        url: `scrap-metal-price/${
          country.name !== "International" ? country.slug + "/" : ""
        }${material}`,
      })
    })
  })

  const materialPricePages = {
    titleKey: "sitemap_Price_material_pages_title",
    title: "Price material pages",
    multilanguage: true,
    links: materialPriceLinks,
  }

  return materialPricePages
}

module.exports = {
  pricePagesLinks,
  materialPricePagesLinks,
}
